import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { DrugCoverageFilterOption } from "../../../@types";
import {
  addNewRelicPageAction,
  useTranslate,
  sendTealiumEvent,
} from "../../../helpers";
import { CCXPDropdown } from "../../../components";
import AppStore from "../../../app/store/AppStore";
import { useFlags } from "launchdarkly-react-client-sdk";
import { SearchFilterKeys } from "./constants";
import { searchResultsFilterAnalytics } from "./helpers";

const DrugCoverageFilter: React.FunctionComponent<{
  onFilterUpdate: (newValue: DrugCoverageFilterOption | undefined) => void;
  basicMode?: boolean;
}> = ({ onFilterUpdate, basicMode }) => {
  const t = useTranslate();
  const flags = useFlags();
  const {
    state: { searchResultsFilters },
    state,
  } = useContext(AppStore.AppContext);
  const [selection, setSelection] = useState(
    searchResultsFilters.drugCoverageFilter
  );

  const updateFilters = (newValue: string): void => {
    addNewRelicPageAction("Search Results Filter", {
      filter: "Drug Coverage",
      value: newValue !== "" ? newValue : "Not Selected",
    });
    searchResultsFilterAnalytics({
      state,
      flags,
      filterValue: newValue,
      filterType: SearchFilterKeys.drugCoverageFilter,
    });
    sendTealiumEvent(
      "Find Plans - Available Plans",
      "Drug Coverage Options Pull down"
    );
    onFilterUpdate(newValue as DrugCoverageFilterOption);
  };

  useEffect(() => {
    setSelection(searchResultsFilters.drugCoverageFilter);
  }, [searchResultsFilters.drugCoverageFilter]);

  const label = t("search_results_page.drug_coverage_options");
  const choices = [
    {
      label: t("search_results_page.includes_drug_coverage"),
      value: DrugCoverageFilterOption.INCLUDES,
    },
    {
      label: t("search_results_page.excludes_drug_coverage"),
      value: DrugCoverageFilterOption.EXCLUDES,
    },
  ];

  return basicMode ? (
    <Dropdown
      onChange={({
        currentTarget: { value },
      }: SyntheticEvent<HTMLSelectElement>): void => {
        setSelection(value as DrugCoverageFilterOption);
        updateFilters(value);
      }}
      name="drug-coverage-filter"
      value={(selection as string) || ""}
      label={label}
      id="drug-coverage-filter"
      options={[
        {
          label: t("search_results_page.select_drug_coverage"),
          value: "",
        },
        ...choices,
      ]}
    />
  ) : (
    <div className="Filter">
      <CCXPDropdown
        name="drug-coverage-filter"
        label={label}
        size="wide"
        keepDefaultLabel
        value={selection as string}
        onUpdate={updateFilters}
        options={choices}
      />{" "}
    </div>
  );
};

export default DrugCoverageFilter;
